import React, { useState, useRef, useContext, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { helpAuth } from '../../helpers/helpAuth';
import AuthContext from "../../context/AuthContext";
import { BASE_API } from '../../api/Globals';
import ReCAPTCHA from "react-google-recaptcha";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { Toast } from 'primereact/toast';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { RECAPTCHAKEY, LABELTEXT } from '../../api/Globals';
import { Password } from 'primereact/password'

import { helpHttp } from "../../helpers/helpHttp";

import { Chip } from "primereact/chip"
import { Tooltip } from 'primereact/tooltip';

//import axios from '../../api/axios';
//const LOGIN_URL = '/auth';

const initialForm = {
    login_identifier: "",
    login_secretkey: ""
}

const validationsFrom = (form) => {
    let errors = {};

    if (!form.login_identifier.trim()) {
        errors.login_identifier = "El campo (usuario) es requerido";
    }
    if (!form.login_secretkey.trim()) {
        errors.login_secretkey = "El campo (contraseña) es requerido";
    }
    console.log(errors)
    return errors;
}

const Login = () => {

    const { handleAuth } = useContext(AuthContext);
    const [auth, setAuth] = useState(false);

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState(true);
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [loggedin, setLoggedin] = useState(false);
    const [token, setToken] = useState();
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    //const [perfilid, setPerfilid] = useState(false);

    const captcha = useRef(null);
    const toast = useRef(null);
    let navigate = useNavigate();

    useEffect(() => {
        // Add reCaptcha
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=" + RECAPTCHAKEY
        //script.addEventListener("load", handleLoaded)
        document.body.appendChild(script)
    }, [])

    useEffect(() => {
        let a = helpAuth();

        const hola = () => {
            console.log(a)
            if (a.auth) {
                //if(a.perfil ) {window.location.href = "/#/filtro/na";} 

                if ([3, 5, 20].includes(parseInt(a.perfil))) {
                    return navigate('/dashboard');
                } else if ([2, 4, 13].includes(parseInt(a.perfil))) {
                    return navigate('/filtro/na');
                } else if ([9, 10, 11, 12].includes(parseInt(a.perfil))) {
                    return navigate('/validacion');
                } else if ([17].includes((a.perfil))) {
                    return navigate('/filtro-ct')
                } else if ([16].includes(parseInt(a.perfil))) {
                    if (parseInt(process.env.REACT_APP_SISTEMA) !== 1) {
                        return navigate('/filtro-alumno/na');
                    } else {
                        return navigate('/maquila');
                    }
                } else if ([19].includes(parseInt(a.perfil))) {
                    return navigate('/dashboard')
                } else {
                    alert("ESTE USUARIO NO CUENTA CON UN PERFIL VÁLIDO");
                }
            } else {
                return;
            }
        }

        hola();
    }, []);

    const showToast = (severity, summary, detail) => {
        toast.current.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: 5000
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFrom(form));
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        setErrors(validationsFrom(form));

        if (Object.keys(errors).length === 0) {
            // if(captcha.current.getValue()) {

            const arrUser = {
                "IdUsuario": 0,
                "Usuario": form.login_identifier,
                "Nombre": "",
                "Password": form.login_secretkey,
                "Activo": true,
                "IdEscuela": 6,
                "IdTipoUsuario": 5,
                "IdTienda": 0,
                "Tienda": "",
                "Version": "3.0.1",
                "VersionObsoleta": true
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}Login/LoginTienda`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Access-Control-Allow-Origin': '*'
                },
            }).then((res) => {
                if (res.isSuccess) {
                    let data = res.Respuesta;

                    let perfilid = data.IdTipoUsuario;

                    setResponse(false);
                    handleAuth(data, res.Token);

                    if ([1, 3, 5, 20].includes(perfilid)) {
                        return navigate('/dashboard');
                    } else if ([2, 4, 13].includes(perfilid)) {
                        return navigate('/filtro/na');
                    } else if ([9, 10, 11, 12].includes(perfilid)) {
                        return navigate('/validacion');
                    } else if ([14].includes(perfilid)) {
                        return navigate('/almacen/registro');
                    } else if ([17].includes(perfilid)) {
                        return navigate('/filtro-ct');
                    } else if ([16].includes(parseInt(perfilid))) {
                        if (parseInt(process.env.REACT_APP_SISTEMA) !== 1) {
                            return navigate('/filtro-alumno/na');
                        } else {
                            return navigate('/maquila');
                        }
                    } else if ([19,21].includes(perfilid)) {
                        return navigate('/dashboard');
                    } else {
                        setLoading(false);
                        setForm(initialForm);
                        setResponse("ESTE USUARIO NO CUENTA CON UN PERFIL VÁLIDO");
                    }
                } else {
                    setLoading(false);
                    setForm(initialForm);
                    setResponse(res.Mensaje);
                }
            });
        } else {
            console.log('Por favor acepta el captcha');
            // showToast('error', 'Error de captcha', 'Favor de aceptar el captcha');
        }
        // } else {
        //     console.log("Error en la validación de campos");
        // 	return;
        // }
        setRefreshReCaptcha(r => !r)
    };

    const onVerify = useCallback((token) => {
        console.log(token)
        setToken(token)
    })

    return (
        <div className='surface-ground px-4 py-8 md:px-6 lg:px-8 flex align-items-center justify-content-center'>
            <Toast ref={toast} />

            <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">

                <div className='col-12 flex'>
                    <div className='col-6'>
                        <Chip label={process.env.REACT_APP_ENTORNO} />
                    </div>
                    
                    <div className='col-6 text-right'>
                        <Tooltip target=".custom-target-label"></Tooltip>
                            <a target="_blank" href="https://aescolar.sonora.edu.mx/archivos/Manual_evidencias_directores_SIUNE.pdf"><i className='pi pi-question-circle custom-target-label' data-pr-tooltip='Ver manual de directores' data-pr-position='left' style={{fontSize: '25px', color: '#8b2f3e', cursor: 'pointer'}}></i></a>
                    </div>
                   
                </div>

                <div className="text-center mb-5">
                    <img src="assets/layout/images/LOGOTIPO SEC PNG.png" alt="hyper" height="120" className="mb-3" />
                    <div className="text-900 text-3xl font-medium mb-3">{`ENTREGA DE ${LABELTEXT.toUpperCase()} ESCOLARES`}<br /></div>
                    <div className="text-900 text-xl font-medium mb-3">INICIAR SESIÓN</div>
                    {/*<span className="text-600 font-medium line-height-3">¿No tienes una cuenta?</span>
                    <a href='../#/registro' className="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Regístrate aquí!</a>*/}
                </div>
                {/* <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHAKEY}>
                    <GoogleReCaptcha onVerify={onVerify} refreshReCaptcha={refreshReCaptcha} /> */}
                <form onSubmit={handleLogin}>
                    <label htmlFor="login_id" className="block text-900 font-medium mb-2">Usuario:</label>
                    {errors.login_identifier && <small className="p-error">{errors.login_identifier}</small>}
                    <InputText id="login_id" name="login_identifier" autoComplete='off' type="text" className={`w-full mb-3 ${errors.login_identifier && 'p-invalid'}`} value={form.login_identifier} onChange={handleChange} autoFocus />
                    <label htmlFor="login_key" className="block text-900 font-medium mb-2">Contraseña:</label>
                    {errors.login_secretkey && <small className="p-error">{errors.login_secretkey}</small>}
                    <Password toggleMask feedback={false} id="login_key" autoComplete="new-password" name="login_secretkey" className={`w-full mb-3 ${errors.login_secretkey && 'p-invalid'}`} inputClassName='w-full' value={form.login_secretkey} onChange={handleChange} />

                    {/*<div className="flex align-items-center justify-content-between mb-6">
                        <a href="../#/recuperar-contrasenia" className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">¿Se te olvidó tu contraseña?</a>
                    </div>*/}

                    {/*<div className="field col-12 md:col-12">
                        <div className="recaptcha" align='center'>
                            <ReCAPTCHA
                                ref={captcha}
                                sitekey={process.env.REACT_APP_CAPTCHA}
                            />
                        </div>
                    </div>*/}

                    {/* {loading  && <div><Loader/></div>} */}
                    {response && <MessageDetail color="error" mensaje={response} />}
                    <Button type="submit" loading={loading} label="Ingresar" className="w-full p-button-rounded" />
                </form>
                {/* </GoogleReCaptchaProvider> */}
            </div>
        </div>
    );

}

export default Login;